import type { DialogAPI, DialogProps, DialogStates } from './dialog';

/**
 * @deprecated Use `DialogProps` instead.
 */
export type ModalProps = DialogProps;
/**
 * @deprecated Use `DialogStates` instead.
 */
export type ModalStates = DialogStates;
/**
 * @deprecated Use `DialogAPI` instead.
 */
export type ModalAPI = DialogAPI;
